import { LayersDataProtectionContent, Languages, Locale, RGPDContent } from "src/model/shop.model";

export interface MarketState {
  marketId: number;
  lang: string;
  langId: number;
  languages?: Languages;
  locale?: Locale;
  expeditionDivision: boolean;
  rgpd?: RGPDContent;
  layersDataProtection?: LayersDataProtectionContent;
  apiHost?: string;
  isMarketTaxes?: boolean;
  minOfferPrice?: number;
}

export const marketInitialState: MarketState = {
  marketId: null,
  lang: "",
  langId: 0,
  languages: null,
  locale: null,
  expeditionDivision: false,
  minOfferPrice: 0,
  rgpd: {
    isEnabled: false,
    showPopup: false,
  },
  layersDataProtection: {
    dataController: "",
    purposesAndLegalBases: "",
    recipients: "",
    rights: "",
    additionalInformation: "",
  },
  apiHost: "",
  isMarketTaxes: false,
};
